import { ChatBotMessages } from './bot-messages'

export default {
  bot: {
    ...ChatBotMessages,
  },
  common: {},
}
